{
  "branding": {
    "frontdesk-attribution": "Propulsé par FrontDesk+",
    "practice-logo": "Logo de {{name}}"
  },
  "validation": {
    "required": "Ce champ est obligatoire",
    "invalid-url": "Veuillez entrer une URL valide",
    "pin-too-short": "Le PIN doit contenir au moins 4 caractères",
    "pin-default-rejected": "Le code PIN standard 0000 n'est pas autorisé. Veuillez attribuer votre propre code PIN.",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "Retour",
    "next": "Suivant",
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "done": "Terminé",
    "retry": "Réessayer",
    "clear": "Effacer",
    "close": "Fermer",
    "verifying": "Vérification...",
    "select": "Sélectionner",
    "minutes": "minutes",
    "clock": "",
    "gender": {
      "M": "Homme",
      "W": "Femme",
      "D": "Autre",
      "U": "Inconnu"
    },
    "insurance": {
      "GKV": "Légale",
      "PKV": "Privée",
      "SELFPAY": "Paiement personnel"
    },
    "scroll-up": "Faire défiler vers le haut",
    "scroll-down": "Faire défiler vers le bas"
  },
  "settings": {
    "device-reset": {
      "title": "Réinitialiser l’appareil",
      "description": "Supprimer la connexion au cabinet, les réglages et le code PIN de cet appareil.",
      "confirmation": "Cet appareil devra être configuré à nouveau. La configuration SOL et les données des patients dans inSuite resteront inchangées.",
      "cancel": "Annuler",
      "confirm": "Réinitialiser maintenant"
    },
    "title": "Paramètres",
    "save": "Enregistrer",
    "save-success": "Paramètres enregistrés",
    "save-error": "Échec de l'enregistrement",
    "load-error": "Échec du chargement des paramètres",
    "pin": {
      "title": "PIN requis",
      "description": "Veuillez entrer votre PIN pour accéder aux paramètres.",
      "error": "PIN incorrect. Veuillez réessayer.",
      "backspace": "Effacer le dernier chiffre"
    },
    "connection": {
      "title": "Connexion",
      "description": "Paramètres de connexion au serveur Doc-Cirrus Bridge",
      "bridge-url": "URL Bridge",
      "device-name": "Nom de l'appareil",
      "device-name-placeholder": "par ex. Réception, salle 1, kiosque",
      "device-name-hint": "Nom pour identification dans le tableau de bord Bridge",
      "kim-address": "Adresse KIM (facultatif)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "Test",
      "success": "Connexion réussie",
      "error": "Échec de la connexion",
      "api-unreachable": "API DocCirrus inaccessible",
      "status-title": "État de la connexion",
      "status": {
        "api": "API connectée",
        "ti": "Infrastructure télématique",
        "card-reader": "Lecteur de carte disponible",
        "medical-card": "Carte du cabinet médical (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "Jeton Sol (depuis inSuite)",
      "sol-token-hint": "À copier depuis l'administration Bridge dans inSuite. Nécessaire pour la connexion.",
      "sol-token-show": "Afficher le jeton",
      "sol-token-hide": "Masquer le jeton",
      "bridge-unreachable": "Bridge injoignable. Veuillez vérifier l'adresse et le port.",
      "diagnostic-id": "ID de diagnostic : {{id}}",
      "scan-qr": "Scanner le code QR",
      "scan-title": "Scanner le code QR du Bridge",
      "scan-manual": "Saisir manuellement"
    },
    "terminal": {
      "title": "Lecteur de carte",
      "description": "Sélection du lecteur de carte pour l'infrastructure télématique",
      "select": "Sélectionner le terminal",
      "select-placeholder": "Choisir le terminal...",
      "loading": "Chargement des terminaux...",
      "none-available": "Aucun terminal disponible",
      "none-found": "Aucun terminal trouvé",
      "found": "{{count}} terminal(aux) trouvé(s)",
      "connect-hint": "Connectez-vous d'abord au serveur bridge pour charger les terminaux.",
      "found-count": "Lecteurs de cartes trouvés : {{count}}",
      "refresh": "Recharger les lecteurs de cartes"
    },
    "practice": {
      "title": "Cabinet médical",
      "description": "Informations sur votre cabinet médical",
      "name": "Nom du cabinet médical",
      "name-placeholder": "ex. Dr. Jean Dupont",
      "welcome-message": "Message de bienvenue",
      "welcome-placeholder": "p. ex. Bienvenue dans notre cabinet médical",
      "scheduler-available": "Activer le planificateur",
      "scheduler-available-description": "Permettre aux patients de prendre rendez-vous via la borne libre-service",
      "prescription-available": "Activer le service de prescription",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "Laisser vide pour accueillir les patients dans leur langue. Votre propre texte s'affiche tel quel dans toutes les langues."
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "Enregistré pour tous les appareils le {{value}}",
      "never-saved-default": "Réglage par défaut, pas encore modifié."
    },
    "anamnesis": {
      "title": "Histoire médicale numérique",
      "description": "Affiche un lien et QR code vers votre fournisseur d'antécédents médicaux après l'enregistrement.",
      "enabled": "Afficher le lien sur les antécédents médicaux après l'enregistrement",
      "enabled-description": "Affiche un lien et QR code vers votre fournisseur d'antécédents médicaux après un enregistrement terminé, par exemple Nelly.",
      "url": "Lien vers le fournisseur d'antécédents médicaux",
      "url-hint": "Le lien est statique et identique pour tous les patients.",
      "preview-label": "Aperçu de l'écran de fin",
      "preview-note": "Le lien est statique et identique pour tous les patients.",
      "url-first": "Saisissez d'abord un lien valide pour activer cette option."
    },
    "appearance": {
      "title": "Apparence",
      "description": "Personnaliser l'interface utilisateur",
      "language": "Langue",
      "default-kiosk-language": "Langue du patient par défaut",
      "default-kiosk-language-hint": "Langue dans laquelle démarrent les nouvelles sessions en kiosque pour les patients.",
      "voice-over-volume": "Volume de la voix off",
      "voice-over-hint": "Contrôle le volume de l'assistant vocal off pour l'accessibilité.",
      "language-first": "Afficher le choix de langue au début de la session"
    },
    "security": {
      "title": "Sécurité",
      "description": "PIN pour accéder aux paramètres",
      "pin": "PIN",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "Administration du kiosque",
    "nav": {
      "general": "Général",
      "flows": "Fonctions",
      "anamnese": "Anamnèse numérique",
      "device": "Appareil et connexion"
    },
    "flows": {
      "title": "Fonctions sur le terminal"
    },
    "language": {
      "title": "Langue et voix",
      "description": "Langue et lecture à voix haute pour les patients sur cet appareil."
    }
  },
  "self-service": {
    "title": "Libre-service",
    "step-progress": "Étape {{current}} / {{total}}",
    "flows": {
      "checkin": "Enregistrement",
      "scheduler": "Prendre rendez-vous",
      "prescription": "Ordonnances",
      "locations": "Plan de localisation",
      "emergency": "Urgence"
    },
    "audio-guide": {
      "on": "Son activé",
      "off": "Son désactivé",
      "replay": "Réécouter les instructions",
      "replay-unavailable": "Aucune instruction vocale à réécouter"
    },
    "language-selector": {
      "title": "Sélectionner la langue",
      "description": "Veuillez sélectionner votre langue préférée"
    },
    "settings": "Paramètres",
    "start": {
      "welcome": "Bienvenue",
      "subtitle": "Veuillez sélectionner une option",
      "check-in-label": "Chemin principal",
      "check-in-cta": "Enregistrement",
      "check-in-description": "Vous avez déjà un rendez-vous ? Enregistrez-vous ici.",
      "check-in-hint": "Préparez votre carte",
      "scheduler-label": "Nouveau",
      "scheduler-cta": "Prendre rendez-vous",
      "scheduler-description": "Réserver un nouveau rendez-vous.",
      "location-plan": "Plan de localisation",
      "location-plan-description": "Trouvez votre chemin vers la salle de traitement.",
      "prescription-label": "Ordonnance",
      "prescription-cta": "Ordonnances et commande",
      "prescription-description": "Consultez les ordonnances ou commandez des renouvellements.",
      "emergency-cta": "Alerte d’urgence locale",
      "emergency-description": "Sonore uniquement sur cet appareil, sans appeler de secours.",
      "tap-to-start": "Appuyez pour commencer"
    },
    "offline": {
      "banner-title": "Enregistrement temporairement indisponible",
      "banner-message": "Veuillez parler avec le personnel de la réception pour obtenir de l'aide.",
      "emergency-available": "L’alerte locale reste disponible. Elle n’appelle pas de secours.",
      "flow-disabled": "Temporairement indisponible"
    },
    "readability": {
      "toggle-label": "Mode lecture",
      "on": "Mode lecture",
      "off": "Mode lecture"
    },
    "reset-overlay": {
      "timeout-title": "Séance terminée",
      "timeout-subtitle": "Votre temps est écoulé. Vos données sont en sécurité.",
      "offline-title": "Connexion perdue",
      "offline-subtitle": "La connexion a été interrompue. Veuillez parler avec le personnel de la réception.",
      "interruption-title": "Séance terminée",
      "interruption-subtitle": "Votre session est terminée en toute sécurité.",
      "completion-title": "Merci!",
      "completion-subtitle": "Votre demande a été complétée avec succès.",
      "reassurance": "Vos données personnelles ne sont pas stockées sur cet appareil.",
      "auto-dismiss": "Revenir au démarrage dans {{seconds}} secondes...",
      "dismiss": "Allez pour commencer"
    },
    "timed-terminal": {
      "countdown": "Retour automatique en {{seconds}} secondes",
      "countdown-outcome": "Ce terminal reviendra automatiquement à l’écran de démarrage.",
      "more-time": "Plus de temps",
      "extended": "Délai prolongé"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "Ces questions ne sont pas disponibles dans votre langue. Choisissez une langue proposée ou adressez-vous à l’accueil.",
        "alternatives": "Rendez-vous alternatifs",
        "loading": "Chargement des questions…",
        "reception-fallback": "Veuillez vous adresser à l'accueil.",
        "error-title": "Les questions n'ont pas pu être chargées",
        "language-unavailable-lead": "Ces questions ne sont pas disponibles dans votre langue.",
        "language-unavailable-title": "Veuillez choisir l'une de ces langues",
        "language-unavailable-body": "Ou faites-vous aider à l'accueil."
      },
      "start": {
        "title": "Prendre rendez-vous",
        "subtitle": "Réservez votre rendez-vous préféré en quelques étapes",
        "welcome": "Bienvenue à la prise de rendez-vous",
        "description": "Nous vous guiderons tout au long du processus de réservation",
        "cta": "Prendre rendez-vous maintenant"
      },
      "patient-id": {
        "title": "Identification",
        "subtitle": "Veuillez vous identifier",
        "mode-card": "Avec carte",
        "mode-search": "Rechercher",
        "mode-create": "Créer nouveau",
        "insert-card": "Veuillez insérer votre carte d'assurance",
        "reading-card": "Lecture de la carte...",
        "simulate-card": "Simuler la carte",
        "multiple-matches": "Plusieurs patients trouvés. Utilisation des données de la carte.",
        "search-placeholder": "Nom ou numéro d'assurance...",
        "searching": "Recherche...",
        "no-results": "Aucun résultat trouvé",
        "first-name": "Prénom",
        "last-name": "Nom",
        "dob": "Date de naissance",
        "insurance": "Assurance",
        "continue": "Continuer",
        "creating": "Créer des patients...",
        "patient-created": "Patient créé avec succès !",
        "create-error": "Impossible de créer le patient."
      },
      "appointment-type": {
        "title": "Sélectionner le type de rendez-vous",
        "subtitle": "Veuillez sélectionner la raison de votre visite",
        "loading": "Chargement des types de rendez-vous...",
        "no-types": "Aucun type de rendez-vous disponible",
        "error": "Impossible de charger les types de rendez-vous. Veuillez réessayer.",
        "no-bookable": "Ces types de rendez-vous ne peuvent pas être réservés au kiosque pour le moment. Veuillez vous adresser à l’accueil ou prendre rendez-vous par téléphone.",
        "disabled-default": "Veuillez prendre ce rendez-vous directement à l’accueil ou par téléphone.",
        "disabled-footer": "Accueil/téléphone uniquement",
        "lead": "Quel type de rendez-vous souhaitez-vous prendre ?",
        "duration": "env. {{minutes}} minutes",
        "empty-title": "Aucun rendez-vous ne peut être pris ici pour le moment",
        "none-bookable-title": "Vous ne pouvez pas prendre ces rendez-vous ici",
        "none-bookable-body": "Veuillez demander à l'accueil ou nous appeler."
      },
      "types": {
        "general": "Consultation générale",
        "general-desc": "Pour les plaintes et questions générales",
        "checkup": "Examen préventif",
        "checkup-desc": "Examens de santé réguliers",
        "vaccination": "Vaccination",
        "vaccination-desc": "Planifier une vaccination",
        "followup": "Suivi",
        "followup-desc": "Rendez-vous de contrôle",
        "prescription": "Ordonnance",
        "prescription-desc": "Retrait d'ordonnance"
      },
      "slot-selection": {
        "title": "Sélectionner un rendez-vous",
        "subtitle": "Veuillez sélectionner un rendez-vous disponible",
        "loading": "Chargement des rendez-vous disponibles...",
        "no-slots": "Aucun rendez-vous disponible",
        "no-appointment-type": "Aucun type de rendez-vous sélectionné",
        "error": "Impossible de charger les créneaux disponibles. Veuillez réessayer.",
        "quick-select": "Prochains rendez-vous disponibles:",
        "select-date": "Ou sélectionnez une date:",
        "times-for": "{{date}}",
        "available": "Disponible",
        "unavailable": "Aucun créneau",
        "slots": "créneaux",
        "select-time-hint": "Appuyez sur une heure pour réserver votre rendez-vous",
        "week-short": "Sem",
        "weekday-mon": "Lun",
        "weekday-tue": "Mar",
        "weekday-wed": "Mer",
        "weekday-thu": "Jeu",
        "weekday-fri": "Ven",
        "weekday-sat": "Sam",
        "weekday-sun": "Dim",
        "period-morning": "Matin",
        "period-midday": "Midi",
        "period-afternoon": "Après-midi",
        "period-evening": "Soir",
        "period-morning-short": "Mat",
        "period-midday-short": "Midi",
        "period-afternoon-short": "A-M",
        "period-evening-short": "Soir",
        "period-dots-legend": "Disponibilité horaire",
        "filter-hint": "Filtrer par horaires préférés:",
        "or-choose-below": "ou choisissez ci-dessous",
        "no-slots-period": "Pas de créneaux",
        "show-all": "Afficher tout",
        "free": "gratuit",
        "your-selection": "Votre sélection",
        "oclock": "heures",
        "choose-slot": "Choisir un emplacement",
        "choose-day": "Choisir un jour",
        "choose-day-first": "Veuillez d'abord choisir un jour",
        "times-heading": "Horaires libres le {{date}}",
        "time-value": "{{time}}",
        "empty-title": "Aucun rendez-vous libre en {{month}}",
        "empty-body": "Regardez le mois suivant ou demandez à l'accueil – nous vous aidons volontiers.",
        "next-month": "Mois suivant",
        "previous-month": "Mois précédent"
      },
      "confirmation": {
        "patient-responses": "Vos réponses",
        "review-loading": "Vérification du résumé…",
        "review-unavailable": "Résumé indisponible. Veuillez réessayer ou demander à l'accueil.",
        "check-booking": "Vérifier la réservation",
        "title": "Confirmer le rendez-vous",
        "subtitle": "Veuillez vérifier votre réservation",
        "patient": "Patient",
        "datetime": "Date et heure",
        "booking": "Réservation...",
        "confirm": "Réserver le rendez-vous",
        "heading": "Est-ce que cela semble correct ?",
        "lead": "Merci de confirmer votre rendez-vous.",
        "appointment": "Rendez-vous",
        "insured-via": "Assuré à travers",
        "description-label": "Notes pour le cabinet (facultatif)",
        "description-hint": "Dites-nous s’il y a quelque chose à prendre en compte lors de la prise de rendez-vous ou de l’accueil.",
        "description-placeholder": "p. ex. mobilité réduite, accompagnant, remarques importantes",
        "description-too-long": "Veuillez limiter la note à 500 caractères maximum.",
        "summary": "Résumé",
        "change": "Changement",
        "book-binding": "Prendre rendez-vous",
        "cancel": "Annuler",
        "type-label": "Type de rendez-vous",
        "datetime-value": "{{date}} à {{time}}",
        "name-label": "Nom",
        "insurance-label": "Assurance",
        "insurance-GKV": "Assurance maladie légale",
        "insurance-PKV": "Assurance maladie privée",
        "insurance-SELFPAY": "Paiement personnel",
        "change-time": "Modifier le rendez-vous",
        "description-free-text": "Autres remarques (facultatif)",
        "note-wheelchair": "J'utilise un fauteuil roulant",
        "note-companion": "Je viens accompagné(e)",
        "note-interpreter": "J'ai besoin d'un interprète"
      },
      "done": {
        "title": "Rendez-vous réservé!",
        "label": "Réservé",
        "subtitle": "Votre rendez-vous a été réservé avec succès.",
        "date": "Date",
        "time": "Heure",
        "booking-id": "Numéro de réservation",
        "qr-hint": "Ajouter au calendrier",
        "qr-description": "Scannez ce code QR avec l'appareil photo de votre smartphone pour ajouter le rendez-vous à votre application de calendrier",
        "auto-redirect": "Vous serez redirigé vers la page d'accueil sous peu...",
        "auto-redirect-countdown": "Retour au début dans {{seconds}} secondes...",
        "back-to-start": "Retour au début",
        "print-button": "Imprimer le justificatif de rendez-vous",
        "print-preparing": "Préparation de l’aperçu avant impression…",
        "print-error": "Le justificatif de rendez-vous n’a pas pu être ouvert. Réessayez ou demandez de l’aide à l’accueil.",
        "print-returned": "L’aperçu d’impression du système a été fermé. Vous pouvez demander un autre exemplaire si nécessaire.",
        "print-title": "Votre rendez-vous",
        "print-location": "Lieu",
        "print-map-hint": "Ouvrir le lieu sur votre téléphone",
        "print-error-v2": "Le ticket de rendez-vous n'a pas pu être ouvert. Veuillez réessayer ou demander à l'accueil."
      },
      "error": {
        "assistance-info": "Nous n'avons pas pu confirmer votre réservation. Votre rendez-vous est peut-être déjà pris. Veuillez demander à l'accueil.",
        "pending-title": "Réservation non confirmée",
        "pending-info": "Nous n'avons pas pu confirmer votre réservation. Votre rendez-vous est peut-être déjà pris. Veuillez vérifier à nouveau ou demander à l'accueil.",
        "title": "Échec de la réservation",
        "subtitle": "Le rendez-vous n'a pas pu être réservé.",
        "info": "Veuillez réessayer ou demander à l'accueil."
      },
      "phase": {
        "identify": "S'identifier",
        "choose": "Choisir l'heure",
        "confirm": "Confirmer"
      }
    },
    "prescription": {
      "start": {
        "title": "Ordonnances et commande",
        "subtitle": "Insérez votre carte d'assurance pour consulter les ordonnances ou commander des renouvellements.",
        "button": "Insérer la carte"
      },
      "card-check": {
        "loading": "Chargement du lecteur de carte...",
        "no-terminal": "Aucun lecteur de carte configuré",
        "no-terminal-hint": "Veuillez contacter le personnel pour obtenir de l'aide.",
        "insert-card": "Veuillez insérer votre carte",
        "insert-card-hint": "Insérez votre carte d'assurance dans le lecteur de carte.",
        "card-detected": "Carte détectée",
        "reading": "Carte de lecture...",
        "reading-hint": "Veuillez patienter un instant.",
        "error": "Erreur de lecture de la carte",
        "retry": "Réessayez",
        "manual-lookup": "Continuer sans carte",
        "load-error": "Impossible de charger le lecteur de carte",
        "read-error": "La carte n'a pas pu être lue"
      },
      "patient-selection": {
        "title": "Sélectionner un patient",
        "subtitle": "Plusieurs patients ont été retrouvés. Veuillez sélectionner votre nom.",
        "try-again": "Réessayez",
        "try-again-hint": "Insérez à nouveau la carte"
      },
      "list": {
        "title": "Vos ordonnances",
        "for-patient": "Ordonnances pour {{name}}",
        "loading": "Chargement des ordonnances...",
        "error-title": "Erreur de chargement",
        "fetch-error": "Les ordonnances n'ont pas pu être chargées",
        "back-home": "Retour au début",
        "done": "Terminé"
      },
      "detail": {
        "prescription-info": "Informations sur la prescription",
        "date": "Date",
        "prescriber": "Prescripteur",
        "comment": "Remarque",
        "medications": "Médicaments",
        "form": "Formulaire",
        "pack-size": "Taille du paquet",
        "manufacturer": "Fabricant",
        "loading": "Chargement de l'ordonnance...",
        "fetch-error": "Les détails de la prescription n'ont pas pu être chargés",
        "back-to-list": "Retour à la liste",
        "print": "Imprimer"
      },
      "types": {
        "public": "Prescription publique",
        "private": "Ordonnance privée",
        "long-term": "Prescription à long terme",
        "btm": "Prescription de stupéfiants",
        "g": "Prescription verte",
        "t": "Prescription T"
      },
      "no-patient": {
        "title": "Patient introuvable",
        "subtitle": "Malheureusement, aucun patient n'a été trouvé pour cette carte. Veuillez contacter le personnel pour obtenir de l'aide.",
        "try-again": "Réessayez",
        "back-home": "Retour au début",
        "title-v2": "Aucune donnée correspondante",
        "subtitle-v2": "Nous n'avons pas pu vous trouver. Veuillez réessayer ou demander à l'accueil."
      },
      "done": {
        "title": "Merci",
        "subtitle": "Vous pouvez vous asseoir maintenant. Si vous avez des questions, veuillez contacter le personnel.",
        "no-prescriptions-title": "Aucune ordonnance au dossier",
        "no-prescriptions-subtitle": "Nous n’avons trouvé aucune prescription active pour vous. Si vous en attendiez un, veuillez contacter le personnel de la réception.",
        "error-title": "Une erreur s'est produite",
        "error-subtitle": "Veuillez contacter le personnel pour obtenir de l'aide.",
        "auto-redirect": "Redirection automatique en {{seconds}} secondes",
        "finish": "Retour au début"
      },
      "hub": {
        "title": "Vos ordonnances",
        "for-patient": "Ordonnances pour {{name}}",
        "loading": "Chargement des ordonnances...",
        "error-title": "Erreur de chargement",
        "fetch-error": "Impossible de charger les ordonnances",
        "back-home": "Retour au début",
        "done": "Terminé",
        "order-button": "Commander une ordonnance",
        "existing-prescriptions": "Vos ordonnances actuelles",
        "no-prescriptions": "Aucune prescription active trouvée."
      },
      "patient-lookup": {
        "title": "Trouver un patient",
        "subtitle": "Entrez votre nom et votre date de naissance.",
        "last-name": "Nom de famille",
        "first-name": "Prénom",
        "date-of-birth": "Date de naissance",
        "lastname": "Nom de famille",
        "lastname-placeholder": "Votre nom de famille",
        "firstname": "Prénom",
        "firstname-placeholder": "Votre prénom",
        "dob": "Date de naissance",
        "search": "Rechercher",
        "searching": "Recherche...",
        "search-error": "Erreur de recherche : {{message}}",
        "no-match": "Aucun patient trouvé. Veuillez vérifier vos informations.",
        "error": "Erreur de recherche. Veuillez réessayer.",
        "found": "Patient trouvé",
        "confirm": "Confirmer",
        "ambiguous": "Plusieurs correspondances",
        "ambiguous-hint-firstname": "Merci de saisir également votre prénom pour affiner la recherche.",
        "ambiguous-hint-additional": "Veuillez vérifier vos informations ou contacter le personnel.",
        "not-found": "Patient introuvable",
        "not-found-hint": "Aucun patient n'a pu être retrouvé avec ces détails.",
        "not-found-action": "Réessayez"
      },
      "manual-identification": {
        "unverified": "Votre identité n’a pas été confirmée avec la carte d’assurance maladie. Le cabinet vérifiera vos informations et votre demande avant de la traiter."
      },
      "medication-selection": {
        "title": "Demander une ordonnance",
        "subtitle": "Le cabinet médical examine votre demande. Une fois approuvée, l'eRx sera prêt dans votre application e-prescription.",
        "back": "Retour",
        "submit": "Continuer à réviser",
        "reason-title": "Pourquoi avez-vous besoin de l'ordonnance ?",
        "reason-hint": "Aide le cabinet médical à évaluer votre demande.",
        "reason-validation": "Veuillez choisir une raison.",
        "reason-schmerzen": "Douleur",
        "reason-entzuendung": "Inflammation",
        "reason-nachsorge": "Après la chirurgie/procédure",
        "reason-allergie": "Allergie/réaction",
        "reason-chronisch": "Maladie chronique",
        "reason-anderes": "Quelque chose d'autre",
        "medications-title": "Quels médicaments ?",
        "request-hint": "Décrivez ce dont vous avez besoin ou nommez l’ordonnance précédente que vous souhaitez renouveler.",
        "request-placeholder": "par ex. Ibuprofène 600 mg, comme la dernière fois",
        "request-validation": "Veuillez décrire le médicament dont vous avez besoin.",
        "history-title": "Ordonnances antérieures",
        "history-hint": "Ajoutez une entrée pour préremplir votre demande.",
        "history-loading": "Chargement des prescriptions précédentes...",
        "history-error": "Les prescriptions précédentes n'ont pas pu être chargées.",
        "history-add": "Ajouter",
        "history-added": "Ajouté",
        "history-date": "Dernier : {{date}}",
        "history-request-line": "Renouveler : {{medicationName}}",
        "urgency-title": "Est-ce urgent ?",
        "urgency-hint": "Aide le cabinet médical à établir la priorité.",
        "urgency-soon": "Urgent",
        "urgency-soon-meta": "Dès que possible",
        "urgency-tomorrow": "Bientôt",
        "urgency-tomorrow-meta": "Dans les prochains jours",
        "urgency-week": "Cette semaine",
        "urgency-week-meta": "Aucune pression de temps",
        "lead": "Le cabinet examine votre demande. Après validation, votre e-ordonnance sera disponible dans l'application e-ordonnance ou sur votre carte d'assurance maladie.",
        "history-hint-v2": "Touchez une ancienne ordonnance pour la reprendre.",
        "history-retry": "Recharger"
      },
      "request-review": {
        "title": "Réviser la commande",
        "subtitle": "Veuillez revoir votre demande de prescription.",
        "request-label": "Médicament demandé",
        "selected-medications": "Médicaments sélectionnés",
        "free-text-medications": "Médicaments supplémentaires",
        "freetext-label": "Autre",
        "quarterly-warning": "Votre carte d'assurance n'a pas été lue ce trimestre. Le cabinet médical peut vous contacter.",
        "egk-warning": "Votre carte d'assurance n'a pas été lue ce trimestre. Le cabinet médical peut vous contacter.",
        "submit": "Soumettre",
        "submitting": "Envoi...",
        "submit-error": "Impossible de soumettre la demande. Veuillez réessayer.",
        "back": "Retour",
        "reason-label": "Raison",
        "urgency-label": "Urgence",
        "completion-email-choice": "Je souhaite recevoir un e-mail lorsque le cabinet aura traité ma demande.",
        "completion-email-label": "Adresse e-mail",
        "completion-email-placeholder": "nom@exemple.fr",
        "completion-email-hint": "Uniquement pour ce message ponctuel. L'adresse n'est pas enregistrée dans les données de base.",
        "completion-email-invalid": "Veuillez saisir une adresse e-mail valide.",
        "egk-proof-required": "Les demandes d’ordonnance ne sont possibles qu’après une lecture réussie de la carte d’assurance. Veuillez vous adresser au personnel.",
        "title-v2": "Vérifier la demande",
        "completion-email-hint-v2": "L'adresse est utilisée uniquement pour ce message."
      },
      "confirmation": {
        "title": "Demande envoyée",
        "subtitle": "Votre demande de prescription a été soumise avec succès.",
        "success-title": "Demande envoyée",
        "success-subtitle": "Votre demande de prescription a été soumise avec succès.",
        "estimated-time": "Votre ordonnance sera prête dans environ {{time}}.",
        "info": "Vous pouvez récupérer votre ordonnance à la pharmacie avec votre carte d'assurance ou l'application eRezept.",
        "auto-redirect": "Redirection automatique en {{seconds}} secondes",
        "back-to-start": "Retour au début",
        "handling-label": "Handled by the practice",
        "next-steps": "Le cabinet examine votre demande. Après validation, vous pourrez utiliser votre e-ordonnance en pharmacie avec votre carte d'assurance maladie ou l'application e-ordonnance."
      },
      "phase": {
        "identify": "S'identifier",
        "request": "Demande",
        "review": "Vérifier"
      }
    },
    "check-in": {
      "flow-label": "Enregistrement",
      "has-appointment": {
        "eyebrow": "Rendez-vous",
        "title": "Avez-vous un rendez-vous?",
        "subtitle": "Veuillez sélectionner une option",
        "yes-label": "Oui",
        "yes": "Oui, j'ai un rendez-vous",
        "yes-description": "Je veux m'enregistrer pour mon rendez-vous.",
        "yes-hint": "Chemin le plus rapide",
        "unsure-label": "Peut-être",
        "unsure": "Je ne suis pas sûr",
        "unsure-description": "Nous vérifierons cela pour vous.",
        "unsure-hint": "Nous vous chercherons",
        "no-label": "Non",
        "no": "Non, sans rendez-vous",
        "no-description": "Je n'ai pas de rendez-vous.",
        "no-hint": "Sans rendez-vous"
      },
      "card-check": {
        "eyebrow": "Carte d'assurance",
        "title": "Lire la carte d'assurance",
        "subtitle": "Veuillez insérer votre carte d'assurance dans le lecteur",
        "insert-title": "Insérez votre carte d’assurance maladie dans le lecteur.",
        "insert-detail": "Nous lisons automatiquement vos coordonnées – vous n’avez rien d’autre à faire.",
        "other-ways": "Autres moyens",
        "no-card-hint": "Si vous n'avez pas votre carte avec vous en ce moment.",
        "pkv-hint": "Utilisez le QR code avec votre application d'assurance.",
        "loading": "Chargement des paramètres...",
        "no-terminal": "Aucun lecteur de carte configuré. Veuillez contacter le personnel.",
        "checking": "Vérification des cartes...",
        "insert-prompt": "Veuillez insérer la carte...",
        "card-detected": "Carte détectée! Prêt à lire.",
        "read-card": "Lire la carte",
        "simulate-insert": "Simuler la carte",
        "reading": "Lecture de la carte...",
        "error": "Impossible de lire la carte. Veuillez réessayer.",
        "read-error": "Échec de la lecture des données de la carte. Veuillez réessayer.",
        "settings-error": "Impossible de charger les paramètres. Veuillez réessayer.",
        "no-card-prompt": "Pas de carte avec vous?",
        "no-card-action": "Recherche manuelle",
        "connection-warning": "Problèmes de connexion avec le lecteur de carte. Veuillez patienter...",
        "pkv-prompt": "Assurance privée ? Online Check-in",
        "pkv-instruction": "Scannez ce QR code avec votre application d'assurance maladie privée pour transmettre vos données numériquement.",
        "pkv-continue": "Continuer vers l'inscription manuelle",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "Veuillez réessayer ou vous enregistrer sans carte. L'accueil vous aidera volontiers.",
        "title-pkv": "Enregistrement par application",
        "title-reading": "Lecture de votre carte …",
        "title-unreadable": "La carte n'a pas pu être lue",
        "title-no-terminal": "Enregistrement sans carte",
        "no-terminal-body": "Le lecteur de cartes n'est pas disponible pour le moment. Veuillez vous enregistrer sans carte ou vous adresser à l'accueil.",
        "reading-detail": "Veuillez laisser la carte dans le lecteur. Cela ne prend qu'un instant.",
        "other-ways-title": "Autres possibilités",
        "no-card-title": "S'enregistrer sans carte",
        "pkv-prompt-title": "Assurance privée ?",
        "pkv-prompt-hint": "Enregistrement avec l'application de votre assurance maladie privée",
        "pkv-close": "Utiliser ma carte finalement",
        "pkv-instruction-app": "Ouvrez l'application de votre assurance maladie privée et scannez ce code. Vos données nous sont alors envoyées directement."
      },
      "patient-selection": {
        "title": "Sélectionner le patient",
        "subtitle": "Plusieurs patients trouvés. Veuillez vous sélectionner.",
        "firstname-label": "Votre prénom",
        "firstname-placeholder": "Entrez le prénom...",
        "confirm-button": "Confirmer",
        "no-match": "Aucun patient correspondant n’a été trouvé. Veuillez vous présenter à la réception pour obtenir de l'aide.",
        "still-ambiguous": "Il reste plusieurs matchs. Veuillez vous présenter à la réception pour obtenir de l'aide.",
        "select-error": "Impossible d'identifier le patient. Veuillez réessayer.",
        "staff-assist": "Allez à la réception",
        "title-v2": "Petite question",
        "subtitle-v2": "Pour votre sécurité, veuillez saisir votre prénom.",
        "no-match-v2": "Nous ne vous avons pas trouvé avec ce prénom. Veuillez vérifier l'orthographe ou vous adresser à l'accueil.",
        "still-ambiguous-v2": "Nous n'avons pas encore pu vous identifier avec certitude. Veuillez vous adresser à l'accueil.",
        "select-error-v2": "Cela n'a malheureusement pas fonctionné. Veuillez réessayer."
      },
      "card-checkin": {
        "title": "Confirmer l'enregistrement",
        "subtitle": "Vos données ont été lues avec succès.",
        "confirm": "Confirmer l'enregistrement"
      },
      "register-from-card": {
        "title": "Nouvelle inscription",
        "subtitle": "Vous n'êtes pas encore dans notre système. Souhaitez-vous vous inscrire?",
        "card-data": "Données de la carte",
        "create": "S'inscrire",
        "create-error": "L'enregistrement a échoué. Veuillez réessayer ou demander de l'aide au personnel.",
        "staff-assist": "Appeler le personnel",
        "no-card-data-title": "Aucune donnée de carte",
        "no-card-data": "Impossible de lire les données de votre carte.",
        "insurance-verified": "Assurance vérifiée : {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "Vos données de la carte",
        "subtitle-v2": "Veuillez vérifier vos données. Si quelque chose est incorrect, touchez « Modifier ».",
        "create-v2": "Confirmer les données",
        "create-error-v2": "L'enregistrement n'a malheureusement pas fonctionné. Veuillez réessayer ou vous adresser à l'accueil.",
        "insurer-missing-v2": "Votre carte n'indique pas votre caisse d'assurance maladie. Veuillez vous adresser à l'accueil.",
        "edit": "Modifier",
        "name": "Nom",
        "insurer": "Caisse d'assurance maladie"
      },
      "patient-lookup": {
        "title": "Rechercher un patient",
        "subtitle": "Veuillez entrer votre nom ou numéro d'assurance.",
        "lastname": "Nom de famille",
        "lastname-placeholder": "Votre nom de famille",
        "dob": "Date de naissance",
        "firstname": "Prénom",
        "firstname-placeholder": "Votre prénom",
        "search": "Rechercher",
        "searching": "Recherche...",
        "search-placeholder": "Nom ou numéro d'assurance...",
        "results-placeholder": "Les résultats de recherche apparaîtront ici",
        "found": "Patient trouvé !",
        "confirm-identity": "Veuillez confirmer que vous êtes le patient indiqué.",
        "confirm-button": "C'est moi",
        "ambiguous-firstname": "Plusieurs patients ont été retrouvés. Veuillez saisir votre prénom.",
        "ambiguous-additional": "Plusieurs patients ont été retrouvés. Veuillez contacter le personnel.",
        "disambiguation-hint": "Cela nous aide à vous identifier clairement.",
        "not-found": "Aucun patient n'a été trouvé avec ces détails.",
        "error": "Erreur de recherche : {{message}}",
        "staff-assist": "Appeler le personnel",
        "not-found-prompt": "Pas trouvé?",
        "register-new": "Nouvelle inscription",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "Enregistrement sans carte",
        "subtitle-firstname": "Veuillez saisir également votre prénom.",
        "ambiguous-firstname-v2": "Plusieurs personnes portent ce nom. Veuillez saisir également votre prénom.",
        "search-again": "Rechercher à nouveau",
        "found-v2": "Nous vous avons trouvé",
        "found-confirm": "Veuillez confirmer avec « C'est moi ».",
        "not-found-title": "Nous ne vous avons pas trouvé",
        "not-found-check": "Veuillez vérifier l'orthographe et la date de naissance. L'accueil vous aidera volontiers.",
        "not-found-reception": "Veuillez vérifier l'orthographe et la date de naissance ou vous adresser à l'accueil.",
        "ambiguous-additional-v2": "Nous n'avons pas pu vous identifier avec certitude. Veuillez vous adresser à l'accueil.",
        "error-v2": "La recherche n'a pas fonctionné pour le moment. Veuillez réessayer."
      },
      "checking-in": {
        "title": "Un instant, nous vous enregistrons.",
        "subtitle": "Nous vous ajoutons à la file d’attente de traitement et en informons l’équipe.",
        "step-insurance": "Assurance vérifiée",
        "step-appointment": "Rendez-vous confirmé",
        "step-waitlist": "Ajout à la liste d'attente",
        "error": "L'enregistrement a échoué. Veuillez réessayer.",
        "continue": "Continuer quand même",
        "title-v2": "Un instant, s'il vous plaît",
        "loading": "Nous vous enregistrons …",
        "subtitle-v2": "Nous vous inscrivons sur la liste d'attente et prévenons l'équipe.",
        "error-title": "Cela n'a malheureusement pas fonctionné",
        "error-v2": "Votre enregistrement n'a pas pu être finalisé.",
        "error-body": "Veuillez réessayer. Si cela ne fonctionne toujours pas, l'accueil vous aidera."
      },
      "appointment-selection": {
        "title": "Sélectionnez un rendez-vous",
        "subtitle": "Vous avez plusieurs rendez-vous aujourd'hui. Veuillez en choisir un.",
        "checking-in": "Enregistrement...",
        "time": "{{time}}",
        "error-v2": "L'enregistrement pour ce rendez-vous n'a pas fonctionné. Veuillez réessayer ou vous adresser à l'accueil."
      },
      "no-appointment": {
        "title": "Aucun rendez-vous trouvé",
        "subtitle": "Nous n'avons pas pu trouver de rendez-vous pour vous aujourd'hui. Veuillez prendre un rendez-vous régulier.",
        "book-appointment": "Prendre rendez-vous",
        "book-appointment-description": "Prenez un nouveau rendez-vous via le planificateur régulier.",
        "staff-assist": "Appeler le personnel",
        "staff-assist-description": "J'ai besoin d'aide.",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "Nous n'avons pas trouvé de rendez-vous pour vous aujourd'hui.",
        "book-v2": "Prendre un nouveau rendez-vous",
        "book-v2-description": "Choisissez maintenant un créneau libre.",
        "have-appointment": "J'ai un rendez-vous",
        "have-appointment-description": "L'accueil vous aidera volontiers.",
        "unavailable-title": "Veuillez prendre rendez-vous à l'accueil",
        "subtitle-unavailable": "Nous n'avons pas trouvé de rendez-vous pour vous aujourd'hui. Veuillez vous adresser à l'accueil."
      },
      "staff-assist": {
        "title": "Personnel averti",
        "subtitle": "Un membre du personnel vous aidera sous peu.",
        "message": "Veuillez patienter ici. Un membre du personnel sera avec vous sous peu.",
        "start-over": "Retour au début",
        "auto-redirect": "Revenir au démarrage dans {{seconds}} secondes..."
      },
      "eeb-prompt": {
        "title": "Vérifier l'assurance",
        "title-failed": "Échec de la vérification",
        "subtitle": "Comment souhaitez-vous vérifier votre assurance?",
        "subtitle-failed": "Scannez le code QR avec l'application de votre assurance pour demander la vérification.",
        "verify-card": "Vérifier électroniquement",
        "verify-card-description": "Envoyer une demande à votre assureur.",
        "select-insurer": "Sélectionner l'assureur",
        "select-insurer-description": "Sélection manuelle de votre assureur.",
        "skip": "Passer",
        "eyebrow-chip": "Alternative",
        "eyebrow": "Enregistrement · preuve d'assurance (eEB)",
        "recommended": "Recommandé",
        "qr-title": "Scannez avec votre application d'assurance",
        "qr-description": "Ouvrez votre application d'assurance maladie et scannez le code : le eEB nous est envoyé directement.",
        "qr-address-label": "Envoyer à",
        "title-app": "Justificatif par application",
        "subtitle-app": "Votre caisse peut aussi nous envoyer le justificatif directement. Quand vous avez terminé, touchez « Suivant »."
      },
      "quarterly-check": {
        "title": "Vérification de l'assurance",
        "checking": "Nous vérifions votre vérification d'assurance actuelle...",
        "error": "La vérification n'a pas pu être effectuée.",
        "title-v2": "Votre assurance",
        "checking-v2": "Nous vérifions votre assurance – un instant, s'il vous plaît.",
        "error-body": "Votre enregistrement est terminé. L'accueil réglera la question de votre assurance avec vous."
      },
      "insurer-prefilled": {
        "title": "Votre assurance maladie",
        "subtitle": "Veuillez confirmer votre assurance pour ce trimestre.",
        "your-insurance": "Votre assurance",
        "last-read": "Dernière vérification le {{date}}",
        "quarterly-notice": "À des fins de facturation, nous avons besoin d'une preuve d'assurance actuelle pour ce trimestre.",
        "confirm-button": "Oui, c'est mon assurance",
        "change-button": "J'ai une assurance différente",
        "contact-title": "Demander une preuve électronique de couverture",
        "contact-description": "Appelez votre assurance et demandez une preuve électronique de couverture pour :",
        "contact-patient": "Patiente",
        "contact-kim-address": "Adresse KIM du cabinet médical",
        "contact-phone": "Téléphone",
        "question": "Est-ce votre caisse d'assurance maladie ?",
        "quarterly-notice-v2": "Une fois par trimestre, nous avons besoin d'un justificatif de votre caisse."
      },
      "insurer-search": {
        "title": "Sélectionner l'assurance maladie",
        "subtitle": "Veuillez rechercher et sélectionner votre assurance maladie légale.",
        "placeholder": "Rechercher une assurance...",
        "hint": "Entrez au moins 2 caractères pour rechercher.",
        "no-results": "Aucune assurance trouvée.",
        "no-results-hint": "Vérifiez l'orthographe ou essayez une autre recherche.",
        "label": "Nom de votre caisse d'assurance maladie",
        "search-error-v2": "La recherche n'a pas fonctionné pour le moment. Veuillez réessayer.",
        "app-alternative": "Plutôt avec l'application de votre caisse ?"
      },
      "insurer-contact": {
        "title": "Demander une preuve d'assurance",
        "subtitle": "Veuillez choisir l'une des options suivantes.",
        "or": "ou",
        "option-eeb-title": "Demande électronique",
        "option-eeb-description": "Si le cas d’exception légal s’applique, vous pouvez transmettre la demande à l’équipe du cabinet après votre consentement.",
        "option-qr-title": "Scanner avec l'application",
        "option-qr-description": "Scannez le QR code avec votre application d'assurance.",
        "option-call-title": "Appelez-vous",
        "option-call-description": "Appelez votre assurance et demandez un eEB pour ce cabinet médical :",
        "phone": "Téléphone",
        "phone-not-available": "Numéro de téléphone sur votre carte d'assurance",
        "patient-name": "Patiente",
        "practice-kim": "Adresse KIM du cabinet médical",
        "help-notice": "Si vous rencontrez des problèmes, veuillez vous rendre à la réception.",
        "submit-eeb-button": "Demander maintenant",
        "contacted-button": "j'ai appelé",
        "contacted-button-countdown": "Heure de votre appel ({{seconds}}s)",
        "go-to-counter-button": "Allez à la réception",
        "qr-continue-button": "j'ai scanné",
        "qr-continue-button-countdown": "Temps de numérisation ({{seconds}}s)",
        "title-v2": "Justificatif de votre caisse d'assurance maladie",
        "subtitle-v2": "Le plus simple est d'utiliser l'application de votre caisse.",
        "subtitle-no-app": "Veuillez choisir comment votre caisse doit nous envoyer le justificatif.",
        "option-eeb-description-v2": "Nous faisons la demande auprès de votre caisse pour vous. Pour cela, nous avons besoin de votre accord.",
        "call-instruction": "Appelez votre caisse et demandez-lui d'envoyer le justificatif à notre cabinet.",
        "call-instruction-practice": "Appelez votre caisse et demandez-lui d'envoyer le justificatif au cabinet {{practice}}.",
        "done-button": "C'est fait – suivant",
        "done-button-countdown": "C'est fait – suivant (encore {{seconds}} s)"
      },
      "eeb-consent": {
        "title": "Consentement",
        "subtitle": "Nous avons besoin de votre consentement pour la vérification électronique de l'assurance.",
        "insurance": "Votre assurance",
        "consent-title": "Consentement pour la vérification électronique de l'assurance (eEB)",
        "consent-text": "Je comprends que mon assurance maladie transmettra mes données d'assurance (par exemple, nom, date de naissance, numéro d'assurance) via le service de communication sécurisé KIM au cabinet médical {{practiceName}} comme preuve d'assurance. Je consens à cette transmission. Je sais que je peux révoquer ce consentement à tout moment sans affecter mon traitement.",
        "withdrawal-notice": "Vous pouvez révoquer ce consentement à tout moment.",
        "agree-button": "J'accepte",
        "decline-button": "Annuler",
        "treatment-notice": "Votre traitement n'est pas affecté par ce consentement.",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "Justificatif de votre caisse d'assurance maladie",
        "summary": "Votre caisse nous envoie le justificatif directement. Pour cela, nous avons besoin de votre accord.",
        "confirm-first": "Veuillez d'abord confirmer la déclaration."
      },
      "qr-code": {
        "title": "Scanner avec l'application d'assurance",
        "instruction-1": "Ouvrez l'application de votre assurance et scannez ce code QR.",
        "instruction-2": "Le cabinet médical recevra ensuite automatiquement votre vérification d'assurance.",
        "practice": "Cabinet médical : {{name}}",
        "alternative-hint": "Alternative: Utilisez l'application de votre assurance",
        "instruction-app": "Ouvrez l'application de votre caisse d'assurance maladie et scannez ce code. Le justificatif nous est alors envoyé directement.",
        "staff-line": "Pour l'équipe du cabinet : {{address}}",
        "staff-line-practice": "Pour l'équipe du cabinet : {{name}} · {{address}}",
        "alternative-app": "Vous pouvez aussi demander le justificatif avec l'application de votre caisse : ouvrez l'application et scannez ce code."
      },
      "register-basics": {
        "title": "Informations personnelles",
        "subtitle": "Veuillez entrer vos informations.",
        "family-name": "Nom",
        "given-name": "Prénom",
        "dob": "Date de naissance",
        "gender": "Sexe",
        "insurance-type": "Type d'assurance",
        "insurer-name": "Nom de votre assurance",
        "insurer-name-placeholder": "par ex. Debeka, DKV, Allianz...",
        "gender-required": "Veuillez choisir une option."
      },
      "register-insurer": {
        "title": "Assurance maladie",
        "subtitle": "Veuillez sélectionner votre assurance maladie.",
        "search-placeholder": "Rechercher une assurance..."
      },
      "register-details": {
        "title": "Résumé",
        "subtitle": "Veuillez vérifier vos informations.",
        "create": "Terminer l'inscription",
        "missing-data": "Veuillez remplir tous les champs obligatoires.",
        "create-error": "L'enregistrement a échoué. Veuillez réessayer.",
        "policy-number": "Numéro de police (facultatif)",
        "policy-number-placeholder": "Votre numéro de police",
        "create-v2": "Terminer l'enregistrement",
        "policy-number-hint": "Vous trouverez le numéro sur la carte de votre assurance."
      },
      "diff-review": {
        "eyebrow-chip": "Examen",
        "eyebrow": "Enregistrement · données de la carte",
        "title": "Comparaison des données",
        "subtitle": "Des différences ont été trouvées entre les données de votre carte et nos dossiers.",
        "col-current": "Record actuel",
        "col-new": "Nouveau de la carte",
        "new-badge": "nouveau",
        "field-fallback": "Champ",
        "note": "Les données mises à jour nous aident à facturer correctement et à vous joindre en cas d'urgence.",
        "comparison-placeholder": "La comparaison sera affichée ici",
        "confirm": "Confirmer les modifications",
        "apply-error": "Les données n'ont pas pu être appliquées. Veuillez réessayer.",
        "retry": "Réessayez",
        "skip": "Continuer quand même",
        "no-changes": "Aucune modification trouvée",
        "title-v2": "Vos données ont changé",
        "subtitle-v2": "Votre carte contient des données plus récentes. Devons-nous les reprendre ?",
        "confirm-v2": "Reprendre et s'enregistrer",
        "keep": "S'enregistrer sans modification",
        "col-current-v2": "Avant",
        "col-new-v2": "Nouveau, depuis la carte",
        "value-yes": "Oui",
        "value-no": "Non"
      },
      "insurance-selection": {
        "title": "Type d'assurance",
        "subtitle": "Veuillez sélectionner votre type d'assurance.",
        "gkv": "Assuré légal",
        "gkv-description": "Membre d'une assurance maladie légale.",
        "pkv": "Privé ou paiement personnel",
        "pkv-description": "Assuré privé ou paiement personnel.",
        "pkv-description-v2": "Assurance maladie privée, ou vous payez vous-même."
      },
      "eeb-request": {
        "title": "Demande enregistrée",
        "subtitle": "Vous pouvez terminer votre enregistrement. La réponse de {{insurer}} arrivera plus tard au cabinet.",
        "verifying": "Votre demande a été acceptée pour un traitement immédiat.",
        "success": "Votre demande a été transmise en toute sécurité à l’équipe du cabinet.",
        "error": "La confirmation de la demande n’est pas disponible.",
        "try-alternative": "Méthode alternative",
        "kim-load-error": "L'adresse KIM du cabinet médical n'a pas pu être chargée.",
        "kim-label": "Cabinet médical · KIM",
        "non-blocking-note": "Cela ne confirme pas encore la réception par votre caisse d’assurance maladie ni votre statut d’assurance.",
        "auto-continue": "Suite automatique dans {{seconds}} secondes.",
        "unavailable-title": "Cela n'a malheureusement pas fonctionné",
        "unavailable-v2": "Votre demande à la caisse d'assurance maladie n'a pas pu être enregistrée.",
        "unavailable-body": "Vous pouvez faire envoyer le justificatif avec l'application de votre caisse ou régler cela à l'accueil.",
        "use-app": "Avec l'application",
        "at-reception": "Régler à l'accueil"
      },
      "self-pay": {
        "title": "Paiement personnel",
        "subtitle": "Vous serez traité comme un patient avec paiement personnel.",
        "info": "Veuillez noter que vous serez responsable des frais de traitement.",
        "confirm": "Compris",
        "title-v2": "Vous payez vous-même",
        "subtitle-v2": "Vous payez le traitement vous-même.",
        "insured-after-all": "Je suis assuré finalement"
      },
      "done": {
        "title": "Terminé!",
        "subtitle": "Votre enregistrement est terminé.",
        "finish": "Terminer",
        "done-label": "Terminé",
        "error-label": "Avis",
        "eyebrow": "Enregistrement · terminé",
        "queue-label": "Salle d'attente",
        "queue-title": "Veuillez vous asseoir",
        "queue-meta": "Nous vous appellerons personnellement.",
        "success-title": "Enregistrement réussi!",
        "success-subtitle": "Veuillez prendre place dans la salle d'attente. Vous serez appelé.",
        "auto-redirect": "Vous serez redirigé vers la page d'accueil sous peu...",
        "auto-redirect-countdown": "Revenir au démarrage dans {{seconds}} secondes...",
        "card-expired-title": "Carte expirée",
        "card-expired-subtitle": "Votre carte d'assurance a expiré.",
        "card-expired-info": "Veuillez contacter le personnel pour obtenir de l'aide.",
        "back-to-start": "Retour au début",
        "anamnesis-title": "Remplir le formulaire d'antécédents médicaux",
        "anamnesis-description": "Scannez le QR code pour remplir facilement votre formulaire d’antécédents médicaux sur votre smartphone.",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "Vous êtes enregistré",
        "card-expired-info-v2": "Veuillez vous adresser à l'accueil."
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "Vérifier vos données",
          "balance-prefix": "À l'enregistrement :",
          "balance-direct-v2": "Enregistré immédiatement : {{count}}",
          "balance-reception-v2": "Vérifié par l'accueil : {{count}}",
          "chip-reception-v2": "Les modifications sont vérifiées par notre accueil",
          "chip-changed": "Modifié : {{count}}",
          "remove": "Supprimer",
          "example-email": "p. ex. nom@exemple.fr",
          "example-phone": "p. ex. 06 12 34 56 78",
          "intro-v2": "Votre enregistrement est terminé. Ces données sont-elles toujours correctes ? La vérification est facultative.",
          "auto-hide": "Les valeurs affichées sont à nouveau masquées après peu de temps."
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "Nous avons transmis cette donnée à l'accueil.",
          "banner-done-v2": "Merci ! Nous avons bien reçu vos données.",
          "footer-v2": "Toutes les autres données restent inchangées."
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "Pour des raisons de confidentialité, nous avons fermé l'affichage. Votre enregistrement est tout de même terminé. Vous pouvez signaler des modifications à l'accueil à tout moment."
        }
      },
      "progress": {
        "identify": "S'enregistrer",
        "insurance": "Assurance",
        "done": "Terminé"
      },
      "dob-format-hint": "Par exemple 01.10.1980",
      "dob-required": "Veuillez saisir votre date de naissance.",
      "insurance-label": {
        "GKV": "Assurance maladie obligatoire",
        "PKV": "Assurance privée",
        "SELFPAY": "Paiement personnel"
      }
    },
    "emergency": {
      "title": "Urgence aiguë !",
      "label": "Urgence",
      "subtitle": "Cette alerte est uniquement audible sur place et n’a appelé aucun secours. En cas d’urgence aiguë ou potentiellement mortelle, appelez le 112.",
      "call-emergency": "Appeler les services d'urgence (112)",
      "stop-sound": "Arrêter le son",
      "play-sound": "Jouer du son",
      "back-to-start": "Retour au début",
      "headline": "Adressez-vous immédiatement au personnel de l'accueil. En cas de danger de mort, appelez le 112."
    },
    "help-reception": "Aide à la réception",
    "help-reception-toast": "Veuillez contacter la réception. Nous sommes heureux de vous aider.",
    "language-entry": {
      "title": "Choisissez votre langue"
    },
    "loading": "Chargement…",
    "step-progress-label": "Progression",
    "step-progress-phase": "Étape {{current}} sur {{total}} : {{phase}}",
    "step-progress-substep": "Partie {{current}} sur {{total}}",
    "step-progress-complete": "Terminé",
    "identification": {
      "title": "Qui êtes-vous ?",
      "lead": "Le plus rapide est d'utiliser votre carte d'assurance maladie. Vous pouvez aussi rechercher avec votre nom.",
      "lead-card-only": "Veuillez insérer votre carte d'assurance maladie dans le lecteur de cartes.",
      "mode-label": "Comment souhaitez-vous vous identifier ?",
      "mode-card": "Avec la carte",
      "mode-search": "Rechercher par nom",
      "mode-create": "Nouveau au cabinet",
      "card": {
        "loading": "Préparation du lecteur de cartes …",
        "checking": "Vérification du lecteur de cartes …",
        "insert-title": "Veuillez insérer votre carte d'assurance maladie dans le lecteur de cartes.",
        "insert-detail": "Nous lisons vos données automatiquement.",
        "detected": "Carte détectée",
        "read": "Lire la carte",
        "reading": "Lecture de la carte …",
        "reading-hint": "Veuillez laisser la carte dans le lecteur.",
        "no-terminal-title": "Lecteur de cartes indisponible",
        "help-with-search": "Veuillez rechercher avec votre nom ou demander à l'accueil.",
        "help-reception": "Veuillez demander à l'accueil – nous vous aidons volontiers.",
        "unreadable-title": "Carte détectée, mais illisible",
        "error-title": "La carte n'a pas pu être lue",
        "not-unique": "Nous n'avons pas pu vous identifier clairement avec cette carte. Veuillez rechercher avec votre nom ou demander à l'accueil.",
        "no-match": "Nous n'avons trouvé aucune donnée pour cette carte. Veuillez rechercher avec votre nom ou demander à l'accueil.",
        "without-card": "Continuer sans carte"
      },
      "lookup": {
        "lead": "Veuillez saisir votre nom de famille et votre date de naissance.",
        "first-name": "Prénom",
        "last-name": "Nom de famille",
        "dob": "Date de naissance",
        "dob-hint": "Format : JJ.MM.AAAA",
        "search": "Rechercher",
        "confirm": "Oui, c'est moi",
        "found-title": "Nous vous avons trouvé",
        "found-body": "Veuillez confirmer qu'il s'agit bien de vous.",
        "first-name-needed-title": "Veuillez ajouter votre prénom",
        "first-name-needed-body": "Pour vous trouver de façon certaine. Touchez ensuite « Rechercher ».",
        "ambiguous-title": "Nous n'avons pas pu vous trouver de façon certaine",
        "ambiguous-body": "Veuillez demander à l'accueil – nous vous aidons volontiers.",
        "not-found-title": "Aucune donnée correspondante",
        "not-found-body": "Veuillez vérifier vos saisies.",
        "error-title": "La recherche n'est pas possible pour le moment",
        "error-body": "Veuillez réessayer ou demander à l'accueil."
      },
      "create": {
        "insurance-question": "Comment êtes-vous assuré ?",
        "insurance-required": "Veuillez choisir votre type d'assurance.",
        "error-title": "Vos données n'ont pas pu être enregistrées",
        "error-body": "Veuillez réessayer ou demander à l'accueil."
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "Débloquez d'abord",
      "subtitle": "FrontDesk+ doit être activé dans votre logiciel de cabinet.",
      "step1": "Commandez chez SolStore (ou votre partenaire Doc-Cirrus commande pour vous).",
      "step2": "Après l'activation, activez dans inSuite sous « inSuite Sols » (droits d'administrateur).",
      "step3": "Ouvrez l'administration Bridge → « Ajouter un appareil ».",
      "cta": "Tout est fait - continuez"
    },
    "welcome": {
      "title": "Ajouter cet appareil au cabinet",
      "scan": "Prendre une photo du code",
      "prepare-link": "Pas de code dans inSuite ?",
      "language": "Langue"
    },
    "scan": {
      "requesting": "L’accès à la caméra est demandé…",
      "scanning": "Pointez la caméra vers le code",
      "paste": "Coller à la place",
      "manual-title": "Connectez-vous manuellement",
      "manual-description": "Si le code QR n'est pas disponible, récupérez les données de connexion auprès de l'administration Bridge.",
      "address-label": "Adresse de Bridge",
      "address-placeholder": "https://…/_rest_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "Insérer SOLTOKEN",
      "manual-submit": "Reprendre la connexion",
      "error-title": "Code non reconnu",
      "camera-denied-title": "Accès à la caméra refusé",
      "camera-denied-hint": "Veuillez autoriser l'accès à la caméra dans les paramètres et réessayer.",
      "retry": "Essayer à nouveau"
    },
    "preflight": {
      "title": "Sera mis en place",
      "all-green": "Tous les tests réussis",
      "practice": "Pratique",
      "device-name": "Nom de l'appareil",
      "device-name-placeholder": "par ex. B. Réception 1",
      "card-reader": "Lecteur de carte",
      "pin": "Nouveau numéro secret",
      "pin-placeholder": "Code PIN à quatre chiffres",
      "finish": "Finition",
      "recheck": "Revérifier",
      "diagnosis": "ID de diagnostic",
      "checklist-error": "Le Bridge a refusé la connexion ou est injoignable. Vérifiez le SOLTOKEN et l'adresse du Bridge.",
      "checklist-retry": "Vérifier à nouveau",
      "edit-token": "Modifier le SOLTOKEN",
      "rescan": "Scanner à nouveau le code"
    },
    "persisting": "Enregistrement de la configuration …",
    "success": {
      "title": "Appareil ajouté",
      "detail": "L'appareil vient d'apparaître sur le PC d'entraînement.",
      "starting": "Le mode Patient démarre…"
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "Connexion au logiciel du cabinet",
        "fix": "Bridge Vérifiez la connexion et l'adresse du serveur."
      },
      "missing_insuite_url": {
        "label": "Adresse de inSuite",
        "fix": "Scannez à nouveau le code QR - l'adresse est manquante."
      },
      "missing_server_token": {
        "label": "Jeton de serveur",
        "fix": "Scannez à nouveau le code QR - le jeton est manquant."
      },
      "missing_gateway_session": {
        "label": "Session Gateway",
        "fix": "Connectez-vous à nouveau : la session est manquante."
      },
      "missing_gateway_enrollment": {
        "label": "Enregistrement de l'appareil",
        "fix": "Enregistrez l'appareil sur le Gateway."
      },
      "gateway_not_ready": {
        "label": "Préparation Gateway",
        "fix": "Attendez que le Gateway termine la configuration."
      },
      "token_verification_failed": {
        "label": "Vérification des jetons",
        "fix": "Vérifiez le jeton du serveur ou la connexion Bridge."
      },
      "session_expired": {
        "label": "réunion",
        "fix": "La session a expiré - connectez-vous à nouveau."
      },
      "device_revoked": {
        "label": "État de l'appareil",
        "fix": "Cet appareil a été bloqué. Contactez le cabinet."
      },
      "missing_practice_name": {
        "label": "Nom du cabinet",
        "fix": "Le nom du cabinet médical n'a pas pu être chargé (inSuite)."
      },
      "missing_device_name": {
        "label": "Nom de l'appareil",
        "fix": "Veuillez saisir un nom d'appareil."
      },
      "telematik_unavailable": {
        "label": "Infrastructure télématique",
        "fix": "Facultatif — le contrôle de la carte reste possible dès que le TI est disponible."
      },
      "selected_card_reader_unavailable": {
        "label": "Lecteur de carte",
        "fix": "Facultatif : sélectionnez ou connectez un lecteur de carte."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "Facultatif : insérez la carte d'accréditation de la pratique médicale (SMC-B)."
      }
    },
    "token": {
      "title": "Saisir le SOLTOKEN",
      "description": "Pour des raisons de sécurité, le code QR ne contient pas le SOLTOKEN. Copiez-le dans inSuite sous « Sol-Aktivierung » (FrontDesk+) et collez-le ici.",
      "submit": "Continuer",
      "rescan": "Scanner à nouveau le code"
    }
  }
}
